import { render } from "./ListsRejects.vue?vue&type=template&id=239d796c&scoped=true"
import script from "./ListsRejects.vue?vue&type=script&lang=ts"
export * from "./ListsRejects.vue?vue&type=script&lang=ts"

import "./ListsRejects.vue?vue&type=style&index=0&id=239d796c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-239d796c"

export default script